<template>
  <v-row>
    <!-- <v-col cols="0" md="1"> </v-col> -->
    <v-col class="pa-0 mt-3" cols="12" md="4">
      <canvas @click="SetCancas()" id="myCanvas" class="CancasSize"> </canvas>
    </v-col>
    <v-col cols="12" md="7" class="pa-0">
      <v-text-field
        v-model="InputCode"
        @change="VerifyCode()"
        label="輸入驗證碼"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>
<style scoped>
.CancasSize {
  border: 1px solid #000;
  width: 100%;
  height: auto;
  max-width: 100px !important;
}
</style>
<script>
export default {
  data() {
    return {
      CorrectCode: null,
      InputCode: null,
      VerifyState: false,
    };
  },
  components: {},
  mounted() {
    this.SetCancas();
  },
  methods: {
    SetCancas() {
      this.VerifyState = false;
      this.$emit("value-update", this.VerifyState);
      //畫布設定
      let canvas = document.getElementById("myCanvas");
      let ctx = canvas.getContext("2d");
      let winW = "120";
      let winH = "40";
      canvas.width = winW;
      canvas.height = winH;

      //背景顏色
      ctx.fillStyle = "#FFFFFF";
      ctx.fillRect(0, 0, 160, 40);

       //繪製點(雜訊)
      for(let i = 0 ; i < 800 ; i++)
      {
        this.drawPoint(ctx);
      }


      //寫入文字
      this.CorrectCode = this.getCode(4).toUpperCase();
      ctx.font = "bold 40px Georgia";

      // let color = this.randomColor_hsl();
      let color = this.randomColor_rgb()
      ctx.fillStyle = color;

      ctx.fillText(this.CorrectCode, 8, 30);

     
    },
    getCode(length) {
      // let str = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789";
      let str = "0123456789";
      let string = "";
      for (let i = 0; i < length; i++) {
        string += str[Math.floor(Math.random() * str.length)];
      }
      return string;
    },
    randomColor_rgb() {

  
      let r = 255;
      let g = 255;
      let b = 255;

      //以白色為基準做比較，0-100為差異範圍，小於40直接捨棄，避免顏色太相近
      // let difference = 0;

      // while (difference < 40) {
      //   r = Math.floor(Math.random() * 256);
      //   g = Math.floor(Math.random() * 256);
      //   b = Math.floor(Math.random() * 256);

      //   let grey = 0.11 * b + 0.59 * g + 0.3 * r;
      //   difference = ((255 - grey) * 100) / 255;
      // }
      while(Math.abs(r - g) <=30 || Math.abs(r - b) <=30 || Math.abs(b - g) <=30 )
      {
        r = Math.floor(Math.random() * 100+30);
        g = Math.floor(Math.random() * 100+10);
        b = Math.floor(Math.random() * 100+30);
      }
    
      console.log(`rgb(${r},${g},${b})`)


      return `rgb(${r},${g},${b})`;
    },
    randomColor_hsl() {
      let h = 0;
      let s = 50;
      let l = 60;

      h = 360 * Math.random();
      do {
        s = 100 * Math.random();
        l = 100 * Math.random();
      } while (s < 40 || s > 70 || l < 40 || l > 70);

      return `hsl(${h},${s}%,${l}%)`;
    },
    VerifyCode() {
      if (this.CorrectCode === this.InputCode) this.VerifyState = true;
      else this.VerifyState = false;
      this.$emit("value-update", this.VerifyState);
      return;
          },
    drawPoint(context) {

      let red = Math.floor(Math.random() * 200);
      let green = Math.floor(Math.random() * 200);
      let blue = Math.floor(Math.random() * 200);
 
      let rgb = `rgb(${red},${green},${blue})`;

      // 取得隨機顏色
      context.fillStyle = rgb;
      context.beginPath();
      // 生成隨機圓心
      let x = this.getRandom(0,120)
      let y = this.getRandom(0,40)
      // 生成隨機半徑
      let r = Math.random();
      // 生成圓環
      context.arc(x,y,r,0,Math.PI * 2,true);
      context.closePath();
      // 填滿
      context.fill();
      },
      getRandom(min,max){
        return Math.floor(Math.random()*(max-min+1))+min;
      }

  },
};
</script>
